import { render, staticRenderFns } from "./EmailForwarders.vue?vue&type=template&id=05f39376&scoped=true"
import script from "./EmailForwarders.vue?vue&type=script&lang=js"
export * from "./EmailForwarders.vue?vue&type=script&lang=js"
import style0 from "./EmailForwarders.vue?vue&type=style&index=0&id=05f39376&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f39376",
  null
  
)

export default component.exports